import { Cancel, CancelToken } from 'axios';
import { ApiRequestCancelError } from './errors';

/**
 * AbortControllerのAPIのラップ用
 */
export class AbortSignalCancelToken implements CancelToken {
  public promise: Promise<Cancel>;

  public cancel?: Cancel;

  private abortSignal: AbortSignal;

  constructor(abortSignal: AbortSignal) {
    this.abortSignal = abortSignal;
    this.promise = new Promise((resolve) => {
      this.abortSignal.onabort = () => {
        this.cancel = new ApiRequestCancelError('request canceled');
        resolve(this.cancel);
      };
    });
  }

  throwIfRequested(): void {
    if (this.cancel) {
      throw this.cancel;
    }
  }
}
